import React from "react"
import ImageGallery from "react-image-gallery"
import urlBuilder from "@sanity/image-url"

import { mySanityClient } from "../../sanityClient"

const Gallery = ({ rawAlbumData }) => {
  const builder = urlBuilder(mySanityClient)
  const urlFor = source => builder.image(source)

  // create an array of urls for the album
  const imageUrlArray = rawAlbumData.map(imageData => {
    const url = urlFor(imageData.asset.id).url()
    const previewUrl = url + "?h=200" + "&w=200" + "&fm=jpg"
    const altText = imageData.altText
    const imageTitle = imageData.imageTitle
    return {
      original: url,
      originalAlt: altText,
      thumbnail: previewUrl,
      thumbnailAlt: altText,
      description: imageTitle,
    }
  })

  return (
    <ImageGallery
      items={imageUrlArray}
      thumbnailPosition="top"
      showPlayButton={true}
      showIndex
    />
  )
}

export default Gallery
